import React from 'react';
import { BookOpen, Shield, Zap, Utensils, Eye } from 'lucide-react';
export function BlueprintDetails() {
  const cards = [{
    icon: BookOpen,
    title: 'The Territorial Reset:',
    desc: "How to stop the 'bully' cat and calm the 'victim' cat by flipping their internal safety switch in 24 hours."
  }, {
    icon: Shield,
    title: 'The Neutral Zone Strategy',
    desc: 'Setting up a zero-tension base camp to drop cortisol levels, whether they have lived together for 2 days or 5 years.'
  }, {
    icon: Zap,
    title: 'Shared Identity Protocol',
    desc: 'Our signature scent-swap method to erase past grudges and start their relationship from a clean slate'
  }, {
    icon: Utensils,
    title: 'The Peace Ritual',
    desc: 'Using advanced feeding techniques to turn past enemies into inseparable partners at every meal.'
  }];
  return <section className="bg-[#0f0f0f] py-20 px-4 pt-[40px] pb-[40px]" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <div className="text-center mb-[40px]" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white" data-id="element-4">
            What's Inside The Blueprint
          </h2>
          <div className="h-1 w-24 bg-orange-600 mx-auto rounded-full" data-id="element-5"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-6">
          {cards.map((card, index) => <div key={index} className="bg-gray-900 border border-gray-800 p-8 rounded-xl hover:border-orange-500/30 transition-all duration-300 group" data-id="element-7">
              <div className="flex items-center gap-3 mb-6" data-id="element-8">
                <div className="w-12 h-12 bg-orange-900/20 rounded-lg flex items-center justify-center shrink-0 group-hover:bg-orange-600/20 transition-colors" data-id="element-9">
                  <card.icon className="w-6 h-6 text-orange-500" data-id="element-10" />
                </div>
                <h3 className="text-xl font-bold text-white" data-id="element-11">{card.title}</h3>
              </div>
              <p className="text-gray-400 leading-relaxed" data-id="element-12">{card.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}